export const popPage = (v) => $.frame.back_page(v);
